import { render, staticRenderFns } from "./Dynamics.vue?vue&type=template&id=92655a6e&scoped=true"
import script from "./Dynamics.vue?vue&type=script&lang=js"
export * from "./Dynamics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92655a6e",
  null
  
)

export default component.exports